module.exports = __webpack_public_path__ + "static/media/diary.cb1eb64c.png";